/**
 * Lightweight modal wrapper for the sidebar "Add new space" action.
 *
 * Reuses CreateOrgStep inside the shared Modal shell - no confetti, no
 * profile fields, no step indicator. On success closes the modal; the new
 * org is already active via OrgProvider.createOrg.
 *
 * @module components/setup/CreateOrgModal
 */

import React from 'react';
import { Modal } from '../ui/Modal';
import { CreateOrgStep } from './CreateOrgStep';

interface CreateOrgModalProps {
  /** Whether the modal is open. */
  open: boolean;
  /** Close handler - called on backdrop click, Escape, or successful create. */
  onClose: () => void;
}

/** Modal containing the CreateOrgStep form. */
export const CreateOrgModal: React.FC<CreateOrgModalProps> = ({ open, onClose }) => {
  return (
    <Modal open={open} onClose={onClose} title="Create a new space" maxWidth="max-w-md">
      <CreateOrgStep submitLabel="Create" onComplete={onClose} hideHeading />
    </Modal>
  );
};
